import { render, staticRenderFns } from "./autodesk-project-resources.vue?vue&type=template&id=f63dbbfc&scoped=true"
import script from "./autodesk-project-resources.vue?vue&type=script&lang=js"
export * from "./autodesk-project-resources.vue?vue&type=script&lang=js"
import style0 from "./autodesk-project-resources.vue?vue&type=style&index=0&id=f63dbbfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63dbbfc",
  null
  
)

export default component.exports